export const getAssetTypeVariant = (dealType: string) => {
  switch (dealType?.toUpperCase()) {
    case 'EQUITY':
      return 'equity'
    case 'LIQUID_TOKEN':
      return 'liquid_token'
    case 'SAFT':
      return 'saft'
    case 'SAFE':
      return 'safe'
    case 'TOKEN':
      return 'token'
    default:
      return 'unknown'
  }
}

export const getOrderTypeVariant = (orderType: string) => {
  switch (orderType?.toUpperCase()) {
    case 'SELL':
      return 'sell'
    case 'BUY':
      return 'buy'
    default:
      return 'unknown'
  }
} 